/**
 * Gets label for which companies voucher is valid
 */
export default function getRedeemCompanies(companyList: string[]) {
    return companyList.length !== 0 ? companyList.join(", ") : "Traveling.com"
}